import { get, mapValues } from 'lodash'
import { createSelector } from 'reselect'

const getAVMGraphVisibility = history =>
  mapValues(history, perHomeId =>
    Boolean(get(perHomeId, 'valuationCount', 0) > 3)
  )
export const selectAVMGraphVisibility = createSelector(
  state => state.avmHistory,
  getAVMGraphVisibility
)
